import React from 'react';
import {useSelector} from 'react-redux';
import {Col, Row, UiDivider, UiImage, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {MDQIntro} from '~/components/shared/MDQIntro';
import {ReviewItem} from '~/components/shared/ReviewItem';
import {BONE_DENSITY_TEST_KEYS} from '~/constants/medical-questionnaires';
import {RootState} from '~/redux/root-reducer';
import {spacing} from '~/utils/theme/spacing';

interface Props {}

const Questionnaire1Screen = ({}: Props) => {
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const {wpAuthUser} = medicalQuestionnaire;

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === BONE_DENSITY_TEST_KEYS.START);

  return (
    <UiQuestionnaireLayout
      nextScreenKey={BONE_DENSITY_TEST_KEYS.PROFILE}
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      isShowLogin={!wpAuthUser.id}
    >
      <Col alignItems="center" textAlign="center">
        <UiText mt={spacing.medium}>{questionnaire?.questions?.default}</UiText>
        {questionnaire?.descriptions?.default?.map(i => (
          <UiText key={i} fontSize="2xl" fontWeight="bold" mt={spacing.small} px={spacing.small}>
            {i}
          </UiText>
        ))}
        <Row display="flex" justifyContent="center" alignItems="center" mt={spacing.small}>
          <UiImage type="icon" name="clock" boxSize={spacing.small} mr={2} />
          <UiText fontSize="xs" fontWeight="700">
            {questionnaire?.descriptions?.sub}
          </UiText>
        </Row>
        <MDQIntro data={questionnaire?.abouts} px={spacing.tiny} mt={spacing.smedium} />
        <UiDivider borderColor="baseColor" opacity={0.1} w="95%" />
        <ReviewItem reviewList={questionnaire?.userReviews} mt={spacing.small} />
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire1Screen;
